
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlarmAckProposal as ObiAlarmAckProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alarm-ack-proposal.js';
 
 
 

 
 export const ObiAlarmAckProposal = createComponent({
   react: React,
   tagName: 'obi-alarm-ack-proposal',
   elementClass: ObiAlarmAckProposalElement,
   events: {
     
   }
  });
 
 